var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PartImg',{ref:"parent",attrs:{"p-id":this.pId,"p-type":this.pType},on:{"stateChange":_vm.onStateChange,"resize":_vm.onResize,"selected":_vm.onSelected}},[_c('div',{staticClass:"part-content",attrs:{"id":_vm.contentId}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d014024","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part/img/Border.vue
// module id = null
// module chunks = 